<div class="grid-page absolute mx-sm-4 mt-3 d-flex flex-column">
    <dx-tabs
        keyExpr="key"
        [items]="tabs"
        [selectedItemKeys]="[selectedTab]"
        [showNavButtons]="false"
        [iconPosition]="'start'"
        [width]="250"
        (onItemClick)="selectedTab = $event.itemData.key"
    ></dx-tabs>

    <div class="mt-3 tab-content-container">
        @if (selectedTab == 'by hour') {
            <app-file-import-by-hour></app-file-import-by-hour>
        } @else if (selectedTab == 'list') {
            <app-file-import-list></app-file-import-list>
        }
    </div>
</div>
